import { render } from "./Shows.vue?vue&type=template&id=0caf4e30&scoped=true"
import script from "./Shows.vue?vue&type=script&lang=js"
export * from "./Shows.vue?vue&type=script&lang=js"

import "./Shows.vue?vue&type=style&index=0&id=0caf4e30&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0caf4e30"]])

export default __exports__